import { omit, toPairs } from 'ramda';

interface IGeneralModel {
  uuid: string;
}

interface IGeneralPayload<T> {
  data: {
    id?: string;
    type?: string;
    attributes: Partial<T>;
  };
}

export function toApiPayload<T>(payload: T, rest?: Object): IGeneralPayload<T>{
  return {
    data: {
      attributes: payload,
      ...rest
    },
  };
}

export function transformPut<T extends IGeneralModel>(
  payload: T,
  type: string,
  omitKeys: Array<keyof T> = []
): IGeneralPayload<T> {
  return {
    data: {
      id: payload.uuid,
      type,
      attributes: omit(omitKeys as string[], payload) as T,
    },
  };
}

export function transformPost<T extends IGeneralModel>(
  payload: T,
  type: string,
  omitKeys: Array<keyof T> = []
): IGeneralPayload<T> {
  return {
    data: {
      type,
      attributes: omit([...(omitKeys as string[])], payload) as T,
    },
  };
}

export const buildQuery = (obj: { [k: string]: any }): string =>
  toPairs(obj)
    .map(item => `${item[0]}=${encodeURIComponent(item[1])}`)
    .join('&');
